/* eslint-disable */
import React, { useEffect } from "react";
import {
    Box, Button, Grid, Typography,
    Backdrop
} from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
// import { makeStyles } from '@mui/styles';
import Helper from '../../../utility/helper';
import ApiHelper from '../../../utility/ApiHelper';
// import Paper from '@mui/material/Paper';

import { Downgraded, useState } from '@hookstate/core';
import Title from "../../../sharedcomponents/title/title";
import RouteConstants from "../../../constants/routeConstants";
import Complimentary from "./complimentary";
import Purchase from "./purchase";
//  import { createTheme } from '@mui/material/styles';
// import ArrowRightIcon from '@mui/icons-material/ArrowRight';
// const theme = createTheme();
import CustomizedSnackbars from "../../../sharedcomponents/snackbar/snackBar";
import APIURLConstants from "../../../config/config";
import { generatePath, useHistory } from 'react-router-dom';
import AppConstants from "../../../constants/appConstants";
import ParticipantAutoList from "../../../sharedcomponents/participantAutoList/participantAutoList";
import AdditionalPurchase from "./addPurchase";
import TableHeaderData from "./tableHeaderData";
import { useEventState, updateModuleState } from "../../../stores/eventStore";
import { useAgentState } from '../../../hookState/AgentState';
import { FULL_PERMISSION, VIEW_PERMISSION, NO_ACCESS_PERMISSION } from "../../../constants/Constant";
import DetailsComponent from '../../../sharedcomponents/detailsComponent/DetailsComponent';
import UnauthorizedUI from '../../../sharedcomponents/emptyStateContainer/unauthorizedUI';
import { RouterPrompt } from '../../../router/routerPrompt';
import {
    useAgentSaveAsDraftState, setAgentShowConfirmPopUp, resetSaveAsDraftState
} from '../../../hookState/AgentSaveAsDraftState';
import { changeAgentUserHandler } from '../../../utility/agentChangeUtility';
import { isMobile } from 'react-device-detect';

const loader = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
};
const AllStarEndUserTicket = () => {

    const history = useHistory();
    const agentSaveAsDraftState = useAgentSaveAsDraftState();
    // const classes = useStyles();
    const [snackBarProps, setSnackBarProps] = React.useState({
        openSnack: false,
        variant: 'error',
        message: '',
    });
    const [allData, setAllData] = React.useState([]);
    const loading = useState(true);
    const eventState = useEventState();
    const agentState = useAgentState();
    const purchaseLoading = useState(false);
    const [participantList, setParticipantList] = React.useState(null);
    const [participant, setParticipant] = React.useState(null);
    const [purchaseData, setPurchaseData] = React.useState([]);
    const [compData, setCompData] = React.useState([]);
    const [showDetailData, setShowDetailData] = React.useState('');
    const [newSettingData, setNewSettingData] = React.useState([]);
    const [shopperRef, setShopperRef] = React.useState('');
    const [modPermission, setModPermission] = React.useState(null);
    const [showDetails, setShowDetails] = React.useState(false);
    // const [autoApprove, setAutoApprove] = React.useState(0);
    const [disable, setDisable] = React.useState(true)
    const [agentInfo, setAgentInfo] = React.useState(null);
    const [sectionDisable, setSectionDisable] = React.useState(true)
    const [showLoading, setShowLoading] = React.useState(false);
    const gAgentInfo = Helper.getSessionStorage('agentUser');
    const eventInfo = Helper.getStorage('eventInfo');
    const userInfo = Helper.getStorage('userInfo');
    const [moduleDisplayName, setModuleDisplayName] = React.useState('');
    const [isCompDirty, setIsCompDirty] = React.useState(false);
    const [isPurchaseDirty, setIsPurchaseDirty] = React.useState(false);
    const [isAddPurchaseDirty, setIsAddPurchaseDirty] = React.useState(false);
    const [isAdminUser, setIsAdminUser] = React.useState(false);
    const [openBackdrop, setOpenBackDrop] = React.useState(false);
    const [enableConfirmPopup, setEnableConfirmPopup] = React.useState(false);
    const [showConfirmationPopup, setShowConfirmationPopup] = React.useState(false);
    const [pageWidth, setPageWidth] = React.useState(8);// added for ipad and mobile

    useEffect(() => {
        //calculate only incase of desktop view
        if (!isMobile) {
            updateCssPageWidth();
            window.addEventListener('resize', updateCssPageWidth);
        }

        return _ => {
            if (!isMobile) {
                window.removeEventListener('resize', updateCssPageWidth)
            }
        }

    }, []);

    useEffect(() => {

        if (history.location.state !== undefined && history.location.state.displayName) {
            setModuleDisplayName(history.location.state.displayName);
        }

        const eventInfo = Helper.getStorage('eventInfo');
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
        const userInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');
        // const userInfo = Helper.getStorage('userInfo');
        if (agentState && agentState.visible.value) {
            const gAgentInfo = Helper.getSessionStorage('agentUser');
            setAgentInfo(gAgentInfo);
        }
        loading.set(true);

        ApiHelper.get(APIURLConstants.GET_ALLSTAR_TICKET_PRICE(eventInfo.eventID))
            .then(res => {
                if (res.data) {
                    loading.set(false);
                    setAllData(res.data);
                }
            }).catch(err => {
                loading.set(false);
                console.log(err)
            });
        if ((gAgentInfo && agentState.visible.value) &&
            (Helper.isAdminUser(gAgentInfo) ||
                (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)))
        ) {
            getParticipantList();
            setTimeout(() => {
                filteredParticipants();
            }, 500);
        } else if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            getParticipantList();
            setTimeout(() => {
                filteredParticipants();
            }, 500);
        } else {
            getPurchaseData(userInfo.userID)
        }
        getSettingData(userInfo.userID);


        setShowLoading(false);
    }, [])

    useEffect(() => {
        // const eventInfo = Helper.getStorage('eventInfo');
        if (compData.length > 0) {
            setDisable(false)
        }
        // ApiHelper.get(APIURLConstants.GET_EVENT_MODULES(eventInfo.eventID, 1, false))
        //     .then((res) =>
        //     {
        //         if (res.data)
        //         {
        //             res.data.map((auto) =>
        //             {
        //                 if (auto.moduleName === "AllStarTicket")
        //                 {
        //                     setAutoApprove(auto.autoApprove)
        //                 }
        //             })
        //         }
        //     })
        history.location.state != undefined && history.location.state.editMode ? setDisable(true) : null
    }, [])

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        let isAdminUser = false;
        if ((agentState && agentState.visible.value) && (Helper.isAdminUser(gAgentInfo) ||
            (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)))
        ) {
            isAdminUser = true;
        }
        else if (Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            isAdminUser = true;
        }

        const allModules = eventState.moduleState.get() !== null ? eventState.moduleState.get().find(i => i.requestStatus === 'To Do') : null;
        const isInTodo = allModules ? allModules.modules.some(m => m.module === 'AllStarTicket') : false;

        setEnableConfirmPopup((isInTodo && !isAdminUser) ? true : false)
        setIsAdminUser(isAdminUser);

    }, [agentState, eventState])

    useEffect(() => {
        // console.log("comdtaa");
        // console.log(compData.participant, compData)
        if (compData.participant !== undefined) {
            setDisable(true)
        } else {
            setDisable(true)
        }
        history.location.state != undefined && history.location.state.editMode ? setDisable(true) : null
    }, [compData])

    useEffect(() => {
        if (history.location.state && history.location.state.ticketState != null) {
            const ticketInfo = history.location.state.ticketState;
            const index = participantList && participantList.findIndex(
                (user) => user.userID == ticketInfo.userID
            );
            if (index !== null) {
                if (index > -1) {
                    setParticipant(participantList[index]);
                    getPurchaseData(participantList[index].userID)
                    getSettingData(participantList[index].userID)
                }
            }
        } else {
            filteredParticipants()
        }
    }, [participantList])

    useEffect(() => {
        if ((isCompDirty || isPurchaseDirty || isAddPurchaseDirty)) {
            if (!agentSaveAsDraftState.showConfirmPopUp.get()) {
                setAgentShowConfirmPopUp(true);
            }
            setShowConfirmationPopup(true);
        }
        else {
            if (agentSaveAsDraftState.showConfirmPopUp.get()) {
                setAgentShowConfirmPopUp(false);
            }
            setShowConfirmationPopup(false);
        }

    }, [enableConfirmPopup, isCompDirty, isPurchaseDirty, isAddPurchaseDirty])

    useEffect(() => {
        const userInfo = Helper.getStorage('userInfo');
        //console.log('eventState', eventState)
        if (eventState.eventDetail.get() !== null) {
            const index = eventState.eventDetail
                .get()
                .moduleDetails?.findIndex((element) => {
                    if (element.moduleName === 'AllStarTicket') {
                        return true;
                    }
                });
            if (!Helper.isAdminUser(userInfo) || !Helper.isEventStaff(userInfo) || !Helper.isEventAdmin(userInfo)) {
                if (
                    eventState.eventDetail.get() &&
                    ((index > 0 &&
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== null) ||
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details !== '')
                ) {
                    setShowDetails(true);
                    setShowDetailData(
                        eventState.eventDetail.get().moduleDetails[index]
                            ?.details
                    );
                } else {
                    setShowDetails(false);
                    setShowDetailData('');
                }
            }
        }
        if (gAgentInfo && !(Helper.isAdminUser(gAgentInfo) || Helper.isEventAdmin(gAgentInfo))) {
            let modulePermission = eventState.attach(Downgraded).get().permissions &&
                eventState.attach(Downgraded).get().permissions.length > 0 && eventState.attach(Downgraded).get().permissions.filter(item => item.module === "ALLSTARTICKET");
            if (modulePermission != undefined && modulePermission.length > 0 && modulePermission[0].permission === "VIEW") {
                setModPermission(VIEW_PERMISSION);
            } else {
                const permissions = eventState.permissions.attach(Downgraded).get();
                if (permissions && permissions.length > 0) {
                    setModPermission(Helper.getModuleAccessPermission(permissions, 'ALLSTARTICKET'));
                }
            }
        } else if (!(Helper.isAdminUser(userInfo) || Helper.isEventAdmin(userInfo))) {
            let modulePermission = eventState.attach(Downgraded).get().permissions &&
                eventState.attach(Downgraded).get().permissions.length > 0 && eventState.attach(Downgraded).get().permissions.filter(item => item.module === "ALLSTARTICKET");
            if (modulePermission != undefined && modulePermission.length > 0 && modulePermission[0].permission === "VIEW") {
                setModPermission(VIEW_PERMISSION);
            } else {
                const permissions = eventState.permissions.attach(Downgraded).get();
                if (permissions && permissions.length > 0) {
                    setModPermission(Helper.getModuleAccessPermission(permissions, 'ALLSTARTICKET'));
                }
            }
        }
        else {
            setModPermission(FULL_PERMISSION);
        }
    }, [eventState])

    const getSettingData = (userID) => {
        loading.set(true);
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        ApiHelper.get(
            APIURLConstants.GET_TICKET_ALLSTAR_SETTING_BY_USERID(eventInfo.eventID,
                agentConnection && gAgentInfo ?
                    Helper.isAdminUser(gAgentInfo) ||
                        (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)) ? userID : gAgentInfo.userID
                    : userID ? userID : userInfo.userID)
        ).then((res) => {
            loading.set(false);
            if (res.data) {
                // console.log("res.data", res.data.setting);
                setNewSettingData(res.data?.setting)
                setShopperRef(res.data.reference);
            }
        }).catch(err => {
            loading.set(false);
            console.log(err)
        });;
    }

    const updateCssPageWidth = () => {
        let navBarWidth = document.getElementById('navBar') ? document.getElementById('navBar').clientWidth : 0;
        let moduleDrawer = document.getElementById('moduleDrawer') ? document.getElementById('moduleDrawer').clientWidth : 0;
        let totalWidth = navBarWidth + moduleDrawer;

        if (totalWidth === 0) {
            totalWidth = 382;
        }
        if (pageWidth !== totalWidth) {
            setPageWidth(totalWidth);
        }
    }

    const filteredParticipants = () => {
        if (history.location.state && history.location.state.adminParticipantList != null) {
            // console.log(history.location.state);
            setParticipantList(history.location?.state?.adminParticipantList)
        }
    }
    const changeParticipant = (participant) => {
        setParticipant(participant);
        getPurchaseData(participant.userID)
        getSettingData(participant.userID)
    };

    const getPurchaseData = (participantID) => {
        purchaseLoading.set(true);
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        const gAgentInfo = Helper.getSessionStorage('agentUser');
        const agentConnection = Helper.getSessionStorage('agentConnections');
        let isAdmin = 0;
        ApiHelper.get(APIURLConstants.GET_TICKET_ALLSTAR(eventInfo.eventID,
            agentConnection && gAgentInfo ?
                Helper.isAdminUser(gAgentInfo) ||
                    (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)) ? participantID && participantID : gAgentInfo.userID
                : participantID ? participantID : userInfo.userID, isAdmin))
            .then(res => {
                if (res.data) {
                    let newData = [];
                    let newCompData = null;
                    if ((agentState && agentState.visible.value) &&
                        (gAgentInfo && Helper.isAdminUser(gAgentInfo) ||
                            (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)))
                    ) {
                        res.data.rows.map((value) => {
                            // console.log(value,participant);              
                            if (value.userID === participantID) {
                                newCompData = value;
                            }
                            value.ticketAllStars.map((val) => {
                                newData.push(val);
                            })
                        });
                        purchaseLoading.set(false);
                        setPurchaseData(newData);

                    } else if (
                        Helper.isAdminUser(userInfo) ||
                        (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
                    ) {
                        res.data.rows.map((value) => {
                            if (value.userID === participantID) {
                                newCompData = value;
                            }
                            value.ticketAllStars.map((val) => {
                                newData.push(val);
                            })
                        })
                        purchaseLoading.set(false);
                        setPurchaseData(newData);

                    } else {
                        // console.log((agentState && agentState.visible.value) && 
                        // (gAgentInfo && gAgentInfo) ? gAgentInfo.userID : userInfo.userID);
                        const filterData = res.data.rows.filter((user) => user.userID === ((agentState && agentState.visible.value) &&
                            (gAgentInfo && gAgentInfo) ? gAgentInfo.userID : userInfo.userID));
                        // console.log("filterData", filterData);
                        filterData.map((value, i) => {
                            if (i === 0) {
                                // if (value.ticketAllStarSetting) {
                                //     setNewSettingData(value.ticketAllStarSetting?.setting);
                                // }
                                newCompData = value;
                            }

                            value.ticketAllStars.map((val) => {
                                newData.push(val);
                            })
                        })
                        purchaseLoading.set(false);
                        setPurchaseData(newData);
                    }
                    setCompData(newCompData ? newCompData : []);
                }
            }).catch(err => {
                purchaseLoading.set(false);
                console.log(err)
            });
    }
    const getParticipantList = () => {
        const agentInfo = Helper.getStorage('agentUser') ? Helper.getStorage('agentUser') : Helper.getSessionStorage('agentUser');
        const gUserInfo = agentInfo ? agentInfo : Helper.getStorage('userInfo');

        // const gUserInfo = Helper.getStorage('userInfo');
        const gEventInfo = Helper.getStorage('eventInfo');
        if ((gAgentInfo && agentState.visible.value) &&
            (Helper.isAdminUser(gAgentInfo) ||
                (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);

                }
            });
        } else if (
            Helper.isAdminUser(gUserInfo) ||
            (gUserInfo.roles && Helper.isEventAdmin(gUserInfo)) || (gUserInfo.roles && Helper.isEventStaff(gUserInfo))
        ) {
            ApiHelper.get(
                APIURLConstants.GET_ADMIN_EVENT_PARTICIPANTS(gEventInfo.eventID)
            ).then((res) => {
                if (res.data.rows) {
                    const participants = res.data.rows.filter(
                        (participant) =>
                            AppConstants.EVENT_ROLES_VALUES.indexOf(
                                participant.roleName
                            ) == -1
                    );
                    setParticipantList(participants);

                }
            });
        }
    };

    const goBack = () => {
        const userInfo = Helper.getStorage('userInfo');
        const eventInfo = Helper.getStorage('eventInfo');
        if ((agentState && agentState.visible.value) && (Helper.isAdminUser(gAgentInfo) ||
            (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo)))
        ) {
            setCompData([])
            const path = generatePath(RouteConstants.All_STAR_TIKCET, {
                eventID: eventInfo.eventID
            });
            history.push({
                pathname: path,
                state: { ticketState: "" },
            });
        } else if (
            Helper.isAdminUser(userInfo) ||
            (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))
        ) {
            setCompData([])
            const path = generatePath(RouteConstants.All_STAR_TIKCET, {
                eventID: eventInfo.eventID
            });
            history.push({
                pathname: path,
                state: { ticketState: "" },
            });
        } else {
            setCompData([])
            history.goBack()
        }
    }

    const sendCommonEmailTemplate = async () => {
        let postCompData = compData;
        let form = new FormData();
        form.append('UserID', postCompData.userID);
        form.append('EventID', eventInfo.eventID)
        form.append('TemplateType', 'ALLStarTickets')
        form.append('ID', postCompData.ticketAllStarComplimentaryID)
        form.append('ModifyBy', userInfo.userID)
        form.append('TranportType', 'ALLStarTickets')
        form.append('ModuleID', 17)
        form.append('IDs', '')
        return ApiHelper.post(
            APIURLConstants.POST_COMMON_EMAIL_TEMPLATE,
            form
        )
            .then((result) => {
                return result.data;
            })
            .catch((err) => {
                console.log(err);
            });
    };
    const sendAllStarAuditEmailNotification = () => {
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        let postCompData = compData
        let emailNotificationObj = {
            userID: postCompData.userID,
            eventID: eventInfo.eventID,
            templateType: 'ALLStarTickets',
            ID: postCompData.ticketAllStarComplimentaryID,
            ModifyBy: userInfo.userID,
            TranportType: 'ALLStarTickets',
            ModuleID: 17,
            contactName: postCompData.contactName,
            contactEmail: postCompData.contactEmail,
            contactNo: postCompData.contactNo,
            ticketAllStars: purchaseData
        }

        ApiHelper.post(
            APIURLConstants.POST_TICKET_ALL_STAR_NOTIFICATION_EMAIL,
            emailNotificationObj
        )
            .then((result) => {
                // return result.data;
            })
            .catch((err) => {
                console.log(err);
            });

    };
    const finalSubmit = () => {
        setShowLoading(true);
        setSectionDisable(true);
        setDisable(true);
        const eventInfo = Helper.getStorage('eventInfo');
        const userInfo = Helper.getStorage('userInfo');
        let requestObj = {
            AllStarComplimentaryID: compData ? compData.ticketAllStarComplimentaryID : '',
            AllStarTicketIDs: purchaseData ? purchaseData.map(i => i.ticketAllStarID).join(',') : '',
            modifiedBy: userInfo.userID
        }
        ApiHelper.post(APIURLConstants.SUBMIT_ALLSTAR_TICKETS, requestObj).then(async (res) => {
            if (res.data) {
                setIsCompDirty(false)
                setIsPurchaseDirty(false)
                setIsAddPurchaseDirty(false)
                setSnackBarProps({
                    ...snackBarProps,
                    openSnack: true,
                    variant: 'success',
                    message: 'You have Successfully Submitted the Ticket',
                });
                sendCommonEmailTemplate();
                sendAllStarAuditEmailNotification();
                await updateModuleState();
                setTimeout(() => {
                    if (gAgentInfo) {
                        if (Helper.isAdminUser(gAgentInfo) ||
                            (gAgentInfo.roles && Helper.isEventAdmin(gAgentInfo)) || (gAgentInfo.roles && Helper.isEventStaff(gAgentInfo))) {
                            // console.log("into agent admin user");
                            history.push({
                                pathname: generatePath(RouteConstants.All_STAR_TIKCET, {
                                    eventID: eventInfo.eventID,
                                }),
                                state: { ticketState: "" },
                            });
                        } else {
                            history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                                eventID: eventInfo.eventID,
                            }))
                        }
                    } else if (Helper.isAdminUser(userInfo) ||
                        (userInfo.roles && Helper.isEventAdmin(userInfo)) || (userInfo.roles && Helper.isEventStaff(userInfo))) {
                        history.push({
                            pathname: generatePath(RouteConstants.All_STAR_TIKCET, {
                                eventID: eventInfo.eventID,
                            }),
                            state: { ticketState: "" },
                        });
                    } else {
                        history.push(generatePath(RouteConstants.EVENT_DETAIL, {
                            eventID: eventInfo.eventID,
                        }))
                    }

                }, 1000);
            }

        }).catch((error) => {
            console.log(error);
            let message = '';
            if (error.response && error.response.status === 401) {
                message = 'Access denied';
            } else {
                message = 'Error while submitting ticket request';
            }
            setSnackBarProps({
                ...snackBarProps,
                openSnack: true,
                variant: 'error',
                message: message,
            });
        });
    }
    const onCompSave = (data) => {
        //console.log("data", data);
        setSectionDisable(false)
    }
    const onPurchaseSave = () => {
        setSectionDisable(false)
    }
    const onAddPurchaseSave = () => {
        setSectionDisable(false)
    }

    const handleSaveAsDraftOnPromptConfirm = () => {
        if (agentSaveAsDraftState.showConfirmPopUp.get() && agentSaveAsDraftState.agentUserInfo.get()) {
            changeAgentUserHandler(agentSaveAsDraftState.agentUserInfo.get(), agentSaveAsDraftState.userEvents.get());
        }
        else {
            resetSaveAsDraftState();
        }
        return true;
    }
    console.log( "disbales",Helper.isAdminUser(userInfo) ||
    (userInfo.roles && Helper.isEventAdmin(userInfo)) ? (disable && sectionDisable) ? true : false : eventInfo.readonlyOrHide === 1 ? true : modPermission === VIEW_PERMISSION ? true : (disable && sectionDisable) ? true : false);
    return (
        <Box
            sx={{
                width: '100%',
                overflow: 'auto',
                maxHeight: 'calc(100vh - 70px)',
            }}
        >
            {loading.get() ?

                <Box
                    sx={
                        {
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            height: '100%',
                            width: '100%',
                        }
                    }
                >
                    <CircularProgress />
                </Box>
                :
                modPermission && modPermission == NO_ACCESS_PERMISSION ?
                    <UnauthorizedUI showLogout={false} />
                    : (
                        <Box className="contentBox" sx={{
                            position: 'relative'
                        }}>


                            {loading.get() ?
                                <Box
                                    sx={
                                        loading.get()
                                            ? {
                                                paddingTop: '20%',
                                                paddingBottom: '20%',
                                                textAlign: 'center',
                                            }
                                            : ''
                                    }
                                    className={loader}>
                                    <CircularProgress />
                                </Box> :
                                <Box>
                                    <Box sx={{
                                        position: 'fixed',
                                        display: 'flex',
                                        margin: '-16px 10px 10px -15px',
                                        flexDirection: 'column',
                                        width: `calc(100vw - ${pageWidth}px)`,
                                        padding: '16px',
                                        paddingRight: '30px',
                                        zIndex: '1000',
                                        backgroundColor: '#fff'

                                    }}>
                                        <Box component='div'
                                            display="flex"
                                            alignItems="center"
                                            width='100%'
                                        >
                                            <Box sx={{ display: 'flex', width: '50%', justifyContent: 'flex-start' }}>
                                                <Title title={Helper.getModuleName(eventInfo ? eventInfo.moduleDetails : [],
                                                    AppConstants.EVENT_MODULES.ALL_STAR_TICKET)} />
                                            </Box>
                                            <Box
                                                sx={{ display: 'flex', width: '50%', justifyContent: 'flex-end', gap: '10px' }}
                                            >
                                                {showLoading ?
                                                    <Button
                                                        variant="contained"
                                                        disabled
                                                        onClick={finalSubmit}
                                                    > <CircularProgress size={20} color="grey" style={{ position: 'absolute' }} />
                                                        {(history.location.state && history.location.state.ticketState != null && history.location.state.ticketState.requestStatus.toLowerCase() !== "pending") ? "Update & Submit" : ((compData && compData != null && compData.requestStatus != undefined) && compData.requestStatus.toLowerCase() === "pending") ? "Update & Submit" : "Submit"}
                                                    </Button>
                                                    : <Button
                                                        variant="contained"
                                                        onClick={finalSubmit}
                                                        disabled={Helper.isAdminUser(userInfo) ||
                                                            (userInfo.roles && Helper.isEventAdmin(userInfo)) ? (disable && sectionDisable) ? true : false : eventInfo.readonlyOrHide === 1 ? true : modPermission === VIEW_PERMISSION ? true : (disable && sectionDisable) ? true : false}
                                                    >
                                                        {(history.location.state && history.location.state.ticketState != null && history.location.state.ticketState.requestStatus.toLowerCase() !== "pending") ? "Update & Submit" : ((compData && compData != null && compData.requestStatus != undefined) && compData.requestStatus.toLowerCase() === "pending") ? "Update & Submit" : "Submit"}
                                                    </Button>
                                                }
                                                <Button variant="outlined" onClick={goBack}>
                                                    Back
                                                </Button>
                                            </Box>
                                        </Box>
                                        <Box>
                                            {participantList && (
                                                <Box
                                                    sx={{
                                                        width: ' 30%',
                                                        textAlign: 'center',
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        flex: 0.3,
                                                        justifyContent: 'center',
                                                        mx: 'auto',
                                                        mb: 1
                                                        // '& .MuiFormControl-root': { width: '100%' },
                                                    }}>
                                                    <ParticipantAutoList
                                                        disableParticipant={
                                                            history.location.state && history.location.state.ticketState
                                                                ? true
                                                                : false
                                                        }
                                                        participant={participant}
                                                        setParticipant={changeParticipant}
                                                        participantList={participantList}
                                                        modPermission={'FULL'}
                                                    />
                                                </Box>
                                            )}
                                        </Box>
                                    </Box>
                                    <Box
                                        sx={{
                                            position: 'relative',
                                            top: '125px',
                                        }}
                                    >
                                        <Box>
                                            {showDetails ? (
                                                <Box sx={{ wordWrap: 'break-word' }}>
                                                    <DetailsComponent data={showDetailData} />
                                                </Box>
                                            ) : null}
                                        </Box>
                                        <Box component='div'
                                            display="flex"
                                            justifyContent="flex-start"
                                            alignItems="center"
                                        >
                                            <Box sx={{ textAlign: 'center' }}>
                                                <TableHeaderData
                                                    newSettingData={newSettingData}
                                                    purchaseData={purchaseData}
                                                    compData={compData}
                                                />
                                            </Box>
                                        </Box>
                                        <Box>
                                            <Typography variant='caption' color='error' style={{ fontWeight: 500 }}>
                                                Note: Please submit the request for League approval.</Typography>
                                        </Box>
                                        <Grid container spacing={1} sx={{ mt: 2 }}>
                                            <Grid item sm={12} >
                                                <Complimentary
                                                    participant={participant}
                                                    newSettingData={newSettingData}
                                                    snackBarProps={snackBarProps}
                                                    compData={compData}
                                                    setSnackBarProps={setSnackBarProps}
                                                    getPurchaseData={getPurchaseData}
                                                    purchaseData={purchaseData}
                                                    modPermission={modPermission}
                                                    agentInfo={agentInfo}
                                                    // onHideShowButton={onHideShowButton}
                                                    onCompSave={onCompSave}
                                                    isAdminUser={isAdminUser}
                                                    setIsCompDirty={setIsCompDirty}
                                                //onCompDataChange={onCompDataChange}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1} sx={{ mt: 2 }}>
                                            <Grid item sm={12}>
                                                <Purchase
                                                    participant={participant}
                                                    snackBarProps={snackBarProps}
                                                    setSnackBarProps={setSnackBarProps}
                                                    priceValue={allData}
                                                    compData={compData}
                                                    newSettingData={newSettingData}
                                                    loading={loading.get()}
                                                    purchaseLoading={purchaseLoading.get()}
                                                    getPurchaseData={getPurchaseData}
                                                    purchaseData={purchaseData}
                                                    modPermission={modPermission}
                                                    shopperRef={shopperRef}
                                                    agentInfo={agentInfo}
                                                    onPurchaseSave={onPurchaseSave}
                                                    isAdminUser={isAdminUser}
                                                    setIsPurchaseDirty={setIsPurchaseDirty}
                                                />
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={1} sx={{ mt: 2 }}>
                                            <Grid item sm={12}>
                                                <AdditionalPurchase
                                                    compData={compData}
                                                    participant={participant}
                                                    snackBarProps={snackBarProps}
                                                    setSnackBarProps={setSnackBarProps}
                                                    priceValue={allData}
                                                    newSettingData={newSettingData}
                                                    loading={loading.get()}
                                                    purchaseLoading={purchaseLoading.get()}
                                                    getPurchaseData={getPurchaseData}
                                                    purchaseData={purchaseData}
                                                    modPermission={modPermission}
                                                    agentInfo={agentInfo}
                                                    onAddPurchaseSave={onAddPurchaseSave}
                                                    isAdminUser={isAdminUser}
                                                    setIsAddPurchaseDirty={setIsAddPurchaseDirty}
                                                />
                                            </Grid>
                                        </Grid>
                                    </Box>
                                </Box>}
                            {
                                snackBarProps.openSnack && (
                                    <CustomizedSnackbars
                                        {...snackBarProps}
                                        onClose={() =>
                                            setSnackBarProps({ ...snackBarProps, openSnack: false })
                                        }></CustomizedSnackbars>
                                )
                            }

                            {
                                openBackdrop &&
                                <Backdrop
                                    sx={{
                                        color: '#fff',
                                        zIndex: (theme) => theme.zIndex.drawer + 150,
                                    }}
                                    open={openBackdrop}
                                //onClick={handleCloseBackDrop}
                                >
                                    <CircularProgress color="inherit" />
                                </Backdrop>
                            }


                            <RouterPrompt key='All Star Ticket'
                                when={showConfirmationPopup}
                                title="Leave this page"
                                cancelText="No"
                                okText="Yes"
                                onOK={handleSaveAsDraftOnPromptConfirm}
                                onCancel={() => false}
                                message="There are unsaved changes. Do you want to leave this page?"
                            />
                        </Box >
                    )
            }
        </Box>
    );
};

export default {
    routeProps: {
        path: RouteConstants.All_STAR_END_USER_TIKCETS,
        component: AllStarEndUserTicket,
    },
    name: 'AllStarEndUserTicket',
};
